var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisableEditIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "noun_edit_2162449",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24.343,
  height: 24.366,
  viewBox: "0 0 24.343 24.366",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M22.044,30.4A1.724,1.724,0,0,1,20.3,32.119H6.5A1.724,1.724,0,0,1,4.757,30.4V16.55A1.741,1.741,0,0,1,6.5,14.831h7.053L15.786,12.6H6.5a3.979,3.979,0,0,0-4,3.95V30.4a3.985,3.985,0,0,0,4,3.976H20.326a3.985,3.985,0,0,0,4-3.976V21.09L22.1,23.321V30.4Z",
  transform: "translate(-2.5 -10.009)",
  fill: "#999"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M43.6,6.142l-3.129-3.1A1.813,1.813,0,0,0,39.21,2.5h0a1.743,1.743,0,0,0-1.257.513L26.411,14.555a1.774,1.774,0,0,0-.513,1.154l-.205,3.309a1.833,1.833,0,0,0,.513,1.385,1.787,1.787,0,0,0,1.257.513h.1l3.334-.205a1.774,1.774,0,0,0,1.154-.513L43.57,8.681a1.787,1.787,0,0,0,.513-1.257A1.68,1.68,0,0,0,43.6,6.142Zm-7.361,1.77L38.723,10.4l-5.771,5.745-2.488-2.488ZM30.592,18.5l-2.642.154.154-2.642.744-.744,2.488,2.488Zm9.7-9.721L37.825,6.322,39.21,4.937,41.7,7.425Z",
  transform: "translate(-19.742 -2.5)",
  fill: "#999"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisableEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/disableEditIcon.4cb0f9c9d55a1f54a51826418ac9c671.svg";